import TemplatesDictionariesCachedService from '@/core/services/cachedData/TemplatesDictionariesCachedService'

export function getTemplateDictionaries () {
    return TemplatesDictionariesCachedService.data
}

export function getHelpByWidgetsTemplateID (templateID?: number) {
    if (!templateID) {
        return undefined
    }
    return TemplatesDictionariesCachedService.data[templateID]
}
